// src/pages/Empleados.tsx
import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Typography,
} from "@mui/material";

interface Empleado {
  id: number;
  nombre: string;
  rol: string;
  email: string;
}

const Empleados: React.FC = () => {
  const [empleados] = useState<Empleado[]>([
    { id: 1, nombre: "Admin 1", rol: "Admin", email: "admin1@club.com" },
    { id: 2, nombre: "Staff 1", rol: "Staff", email: "staff1@club.com" },
    { id: 3, nombre: "Staff 2", rol: "Staff", email: "staff2@club.com" },
  ]);

  const handleAddEmpleado = () => {
    alert("Funcionalidad para agregar empleado (demo)");
  };

  return (
    <div>
      <Typography variant="h4" gutterBottom>
        Administración de Empleados
      </Typography>
      <Button
        variant="contained"
        color="primary"
        onClick={handleAddEmpleado}
        style={{ marginBottom: "20px" }}
      >
        Agregar Empleado
      </Button>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>Nombre</TableCell>
              <TableCell>Rol</TableCell>
              <TableCell>Email</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {empleados.map((emp) => (
              <TableRow key={emp.id}>
                <TableCell>{emp.id}</TableCell>
                <TableCell>{emp.nombre}</TableCell>
                <TableCell>{emp.rol}</TableCell>
                <TableCell>{emp.email}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default Empleados;
